import React, { useState, useEffect } from 'react';
import { TextField, Autocomplete, CircularProgress } from '@mui/material';
import ApiService from '../services/ApiService';

const ExcelDropdown = ({ 
  value, 
  onChange, 
  error, 
  helperText, 
  disabled,
  label,
  placeholder,
  columnName, // The Excel column name to fetch
}) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    // Only load options when dropdown is opened and we don't have options yet
    if (open && options.length === 0) {
      fetchValues();
    }
  }, [open]);

  const fetchValues = async () => {
    setLoading(true);
    try {
      const response = await ApiService.getExcelData(columnName);
      setOptions(response.values || []);
    } catch (error) {
      console.error(`Failed to fetch ${columnName} values:`, error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Autocomplete
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      value={value}
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      options={options}
      loading={loading}
      disabled={disabled}
      filterOptions={(options, { inputValue }) => {
        // Custom filter function for better search
        const filterValue = inputValue.toLowerCase();
        return options.filter(option => 
          option.toLowerCase().includes(filterValue)
        ).slice(0, 100); // Limit to 100 results for performance
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={!!error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      ListboxProps={{
        style: { maxHeight: 250 }
      }}
    />
  );
};

export default ExcelDropdown;